import React from 'react';
import { Box } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export default function GlowBorderCard({ children, rounded = '2xl', ...props }) {
	return (
		<Box position='relative' rounded={rounded} p='2px' overflow='hidden' {...props}>
			<Box
				position='absolute'
				inset='-100%'
				bg='conic-gradient(from 0deg, #22d3ee, #818cf8, #a855f7, #22d3ee)'
				animation={`${spin} 5s linear infinite`}
				aria-hidden
			/>
			<Box position='relative' rounded={rounded} h='full'>
				{children}
			</Box>
		</Box>
	);
}
